export default __webpack_public_path__ + "static/media/hourglass-start-grey.ca1f51b6.svg";